import {useDispatch, useSelector} from 'react-redux';
import SearchFilterTable from '../../microComponents/tablePages/filter/SearchFilterTable';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import SelectFilterTable from '../../microComponents/tablePages/filter/SelectFilterTable';
import React, {useEffect, useState} from 'react';
import {getFilterDetailsList} from "../../microComponents/tablePages/getFilterDetailsList";
import PriceFilterTable from "../../microComponents/tablePages/filter/PriceFilterTable";
import {activatedJson} from "../../helper/jsons/activatedJson";
import {Switch} from "antd";
import {toast} from "react-toastify";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import Product from "../../http_request/Model/product/Product";

const ProductsColumn = () => {
        const dispatch = useDispatch();

        const filter = useSelector((state) => state.TableRedux.filter);
        const [getColumnSearchProps] = SearchFilterTable();
        const [loading, setLoading] = useState(false);
        const [selectedItem, setSelectedItem] = useState();

        const [handleSetParams] = UseSetParams();
        const [getColumnSelectProps] = SelectFilterTable();
        const [getColumnPriceProps] = PriceFilterTable();

        const [filterDetailsList, setFilterDetailsList] = useState({});
        const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);


        useEffect(() => {
            getFilterDetailsList(setFilterDetailsList, setFilterDetailsListLoading)
        }, [])
        const funcHandleSetParams = (newFilter) => {
            handleSetParams(newFilter);
        };

        const handleStatus = (id, status) => {
            const data = {

                "status": !status,
            }
setSelectedItem(id)
            Product.request({
                beforeSend: () => {
                    setLoading(true)

                }, success: () => {
                    toast.success('تغییرات با موفقیت اعمال شد.');
                    dispatch(getAgainHandler())
                }, error: (error) => {
                    toast.error(error.data.message);

                }, final: () => {
                    setLoading(false)

                },


            }).updateProduct(data,id);

        };


        const columns = [

            {
                title: 'ردیف', className: "hidden lg:table-cell",dataIndex: 'row', key: 'row', render: (text, row, index) => {
                    return index + 1;
                },
            }, {
                title: ' نوع',
                dataIndex: 'type',
                key: 'type', ...getColumnSelectProps(filter.type, 'type', 'نوع', filterDetailsList?.type, null, (res) => {
                    funcHandleSetParams([{key: 'type', value: res}]);
                }, filterDetailsListLoading),
            }, {
                title: ' محصول',
                dataIndex: 'name',
                key: 'name', ...getColumnSearchProps('محصول', filter.name, (res) => {
                    funcHandleSetParams([{key: 'name', value: res}]);
                }, 'name'),
            }, {
                title: ' کد',className: "hidden 2xs:table-cell",
                dataIndex: 'code',
                key: 'code', ...getColumnSearchProps(' کد', filter.code, (res) => {
                    funcHandleSetParams([{key: 'code', value: res}]);
                }, 'code'),
            }, {


                title: ' برند',className: "hidden sm:table-cell",
                dataIndex: 'brand',
                key: 'brand', ...getColumnSelectProps(filter.brand, 'brand', 'محصول', filterDetailsList?.brand, null, (res) => {
                    funcHandleSetParams([{key: 'brand', value: res}]);
                }, filterDetailsListLoading),
            },
            {
                title: 'واحد سنجش',className: "hidden md:table-cell",
                dataIndex: 'unitMeasurement',
                key: 'unitMeasurement', ...getColumnSelectProps(filter.unitMeasurement, 'unitMeasurement', 'واحد سنجش', filterDetailsList?.unitMeasurement, null, (res) => {
                    funcHandleSetParams([{key: 'unitMeasurement', value: res}]);
                }, filterDetailsListLoading),
            },
            {
                title: 'تعداد در پالت',className: "hidden 2md:table-cell",
                dataIndex: 'quantityPerPallet',
                key: 'quantityPerPallet',
            }, {
                title: 'مدت انقضا',className: "hidden lg:table-cell",
                dataIndex: 'expiryDate',
                key: 'expiryDate',
                render: (item, row) => {
                    return <div>{row.expiryDate} {row.exireDateInDays ? 'روز' : 'ماه'}</div>
                }
            },

            {
                title: ' ق.م',className: "hidden lg:table-cell",
                dataIndex: 'consumerPrice',
                key: 'consumerPrice', ...getColumnPriceProps(filter.consumerPriceRials, (res1) => {
                    funcHandleSetParams([{key: 'consumerPriceRials', value: res1}])
                }, 'قیمت مصرف کننده','consumerPriceRials'),
            },
            {
                title: 'ق.ت',className: "hidden lg:table-cell",
                dataIndex: 'manufacturerPrice',
                key: 'manufacturerPrice', ...getColumnPriceProps(filter.manufacturerPriceRials, (res) => {
                    funcHandleSetParams([{key: 'manufacturerPriceRials', value: res}]);
                }, 'قیمت تولید','manufacturerPriceRials'),
            },
            {
                title:" آستانه انقضا (روز)",className: "hidden lg:table-cell",
                dataIndex: 'expireDateThreshold',
                key: 'expireDateThreshold',
            },
            {
                title: 'fifo استانه',className: "hidden lg:table-cell",
                dataIndex: 'fifoThresholdDay',
                key: 'fifoThresholdDay',
            },
            {
                title: 'وضعیت',  fixed: 'right', className: '  cell-fix-left',
                dataIndex: 'status',
                key: 'status', ...getColumnSelectProps(filter.unitMeasurement, 'status', 'وضعیت', activatedJson, null, (res) => {
                    funcHandleSetParams([{key: 'status', value: res}]);
                })
                , render: (item, row) => {
                    return <Switch loading={selectedItem === row.code && loading} onClick={() => {
                        handleStatus(row.code, item)
                    }} checked={item} unCheckedChildren='غیر فعال'
                                   className='bg-amber-600'
                                   checkedChildren='فعال'/>

                }
            }


        ];
        return [columns];
    }
;

export default ProductsColumn;